import React, { useState, useEffect } from "react";
import "./style.css";
import Moment from "react-moment";
import cogoToast from "@successtar/cogo-toast";

function MasterControlUmbrella({ umbrella, agentID }) {
  const [formData, setFormData] = useState({
    commissions: "",
    split: ""
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
    setTimeout(() => {
      calculateCommissions(agentID);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const calculateCommissions = (agentId) => {
    let commissions = 0;
    let split = 0;

    if (agentId === umbrella.mainAgent) {
      commissions = umbrella.premium * (umbrella.mainAgentSplit / 100) * 0.06;
      split = umbrella.mainAgentSplit;
    } else if (agentId === umbrella.refAgentOne) {
      commissions = umbrella.premium * (umbrella.refAgentOneSplit / 100) * 0.06;
      split = umbrella.refAgentOneSplit;
    } else if (agentId === umbrella.refAgentTwo) {
      commissions = umbrella.premium * (umbrella.refAgentTwoSplit / 100) * 0.06;
      split = umbrella.refAgentTwoSplit;
    } else if (agentId === umbrella.refAgentThree) {
      commissions = umbrella.premium * (umbrella.refAgentThreeSplit / 100) * 0.06;
      split = umbrella.refAgentThreeSplit;
    } else if (agentId === umbrella.refAgentFour) {
      commissions = umbrella.premium * (umbrella.refAgentFour / 100) * 0.06;
      split = umbrella.refAgentFourSplit;
    }

    setTimeout(() => {
      setFormData({
        commissions: commissions,
        split: split
      });
    }, 500);
  };

  const viewPolicy = (event) => {
    event.preventDefault();
    console.log("Getting Policy information");
    cogoToast.warn("Website Feature coming soon!");
  };

  const { split, commissions } = formData;

  return (
    <tr key={umbrella._id} style={{ backgroundColor: "white" }}>
      <td>Umbrella</td>
      <td>
        <strong>{umbrella.clientFirstName + " " + umbrella.clientLastName}</strong>
      </td>
      <td>{umbrella.policyActive ? "Active" : "Inactive"}</td>
      <td>${umbrella.premium}</td>
      <td>
        {split ? <>{parseInt(split).toFixed(0)}%</> : <img alt="loading" src="/loading.gif" />}
      </td>
      <td>
        {commissions ? (
          <>${parseInt(commissions).toFixed(2)}</>
        ) : (
          <img alt="loading" src="/loading.gif" />
        )}
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {umbrella.effectiveDate}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {umbrella.updatedAt}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
          {umbrella.created_at}
        </Moment>
      </td>
      <td>
        <button
          className="btn btn-small btn-black"
          style={{ width: "100%" }}
          onClick={(e) => viewPolicy(e)}
        >
          View
        </button>
      </td>
    </tr>
  );
}

export default MasterControlUmbrella;
